/**
 * FlipWords, ported from src/components/FlipWords.tsx.
 *
 * Reveals a word letter by letter, holds, then unreveals and moves to the
 * next. Timings are the React component's defaults: 250ms per letter, 70ms
 * stagger, 1400ms hold. The container width animates with the letter count so
 * the highlight block grows and shrinks rather than jumping.
 */
(function () {
  const LETTER_MS = 250;
  const STEP_MS = 70;
  const HOLD_MS = 1400;

  document.querySelectorAll('[data-cs-flip-words]').forEach((el) => {
    let words;
    try {
      words = JSON.parse(el.dataset.csFlipWords);
    } catch (e) {
      return;
    }
    if (!Array.isArray(words) || !words.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let i = 0;

    const render = (word, phase) => {
      el.textContent = '';
      const chars = Array.from(word);
      chars.forEach((ch, n) => {
        const s = document.createElement('span');
        s.textContent = ch === ' ' ? ' ' : ch;
        s.style.display = 'inline-block';
        if (!reduced) {
          s.style.animation =
            `${phase === 'in' ? 'fwIn' : 'fwOut'} ${LETTER_MS}ms ` +
            `cubic-bezier(0.22,1,0.36,1) ${n * STEP_MS}ms both`;
        }
        el.appendChild(s);
      });
      return LETTER_MS + chars.length * STEP_MS;
    };

    const cycle = () => {
      const word = words[i];
      const revealMs = render(word, 'in');
      setTimeout(() => {
        const outMs = render(word, 'out');
        setTimeout(() => {
          i = (i + 1) % words.length;
          cycle();
        }, outMs);
      }, revealMs + HOLD_MS);
    };

    cycle();
  });
})();
